import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { mockData } from './mockData';

const HeroSection = () => {
  const { hero } = mockData;

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToDemo = () => {
    const element = document.querySelector('#how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-announcement">
          <span>{hero.announcement}</span>
          <ArrowRight size={12} />
        </div>
        
        <h1 className="heading-hero hero-title">
          {hero.title}
        </h1>
        
        <p className="body-large hero-subtitle">
          {hero.subtitle}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button 
            onClick={scrollToContact}
            className="btn-primary hover-scale"
          >
            {hero.primaryCTA}
            <ArrowRight size={16} className="ml-2" />
          </button>
          
          <button 
            onClick={scrollToDemo}
            className="btn-secondary hover-scale"
          >
            <Play size={16} className="mr-2" />
            {hero.secondaryCTA}
          </button>
        </div>
        
        {/* Trust Indicators */}
        <div className="mt-12 text-center">
          <p className="caption mb-6">Trusted by local businesses across industries</p>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <div className="mono-text">Healthcare</div>
            <div className="mono-text">Legal Services</div>
            <div className="mono-text">Home Services</div>
            <div className="mono-text">Beauty & Wellness</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;